import { render, staticRenderFns } from "./RawWaterColumn.vue?vue&type=template&id=8bf89c34&scoped=true"
import script from "./RawWaterColumn.vue?vue&type=script&lang=js"
export * from "./RawWaterColumn.vue?vue&type=script&lang=js"
import style0 from "./RawWaterColumn.vue?vue&type=style&index=0&id=8bf89c34&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf89c34",
  null
  
)

export default component.exports